import React from 'react';
import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';

import { theme } from '@backrs_ui/common-ui';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import { App } from './App';
import { AuthShell } from './providers/AuthShell';
import { HealthCheck } from './providers/HealthCheck';
import { RootAnalyticsProvider } from './providers/RootAnalyticsProvider';
import { store } from './redux/store';
import { reportWebVitals } from './reportWebVitals';

import './index.css';
import '@backrs_ui/common-ui/src/mui-variants.d';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RootAnalyticsProvider>
        <HealthCheck>
          <AuthShell>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <App />
            </ThemeProvider>
          </AuthShell>
        </HealthCheck>
      </RootAnalyticsProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
